// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"7dba6146","53":"1beec4e9","112":"57d7c5fb","221":"68fe6e35","239":"d28a706b","298":"18e920ca","455":"5dec9441","461":"a6e42eb6","526":"e2eb09fd","666":"9f3d89cb","694":"005b4601","718":"6abb7fba","870":"521ac103","885":"7a87c256","887":"408c96f7","931":"b01bbf03"}[chunkId] + ".chunk.js";
};